/* eslint-disable react/jsx-indent */
import * as React from "react";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { Zoom } from "react-awesome-reveal";

import Image from "next/image";
import Link from "next/link";
import { organizationOnePageCards } from "../static/cards";

const useStyles = makeStyles((theme) => ({
  containerParent: {
    marginTop: 50,
  },
  container: {
    width: "100%",
    padding: 0,
    borderRadius: "10px",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
    "&:hover": {
      boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.10)",
    },
    backgroundColor: "#fff",
    border: "solid 1px #009693",
    padding: "20px 0",
  },
  containerDisabled: {
    width: "100%",
    padding: 0,
    borderRadius: "10px",
    backgroundColor: "#fff",
    border: "solid 1px #B6B3B3",
    padding: "20px 0",
  },
  div: {
    margin: "auto",
    padding: 4,
  },
  iconParent: {
    margin: "0 auto",
    width: "50%",
    maxWidth: 100,
  },
  padding: {
    padding: 10,
  },
  t1: {
    color: "#292929",
    fontSize: 18,
    padding: 5,
    paddingBottom: 20,
    marginTop: 10,

    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
    },
  },
  t1Disable: {
    color: "#B6B3B3",
    fontSize: 18,
    padding: 5,
    paddingBottom: 20,
    marginTop: 10,

    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
    },
  },
}));

const Cards = ({ data, giftCarts, salons, projects }) => {
  const classes = useStyles();
  return (
    <Grid container className={classes.containerParent} alignItems="center">
      {organizationOnePageCards(
        data,
        !salons.length,
        !projects.length
      ).map((item, i) => (
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={4}
          key={`organizationOnePageCards-${item.image}`}
          className={classes.padding}
        >
          <div className={classes.div} dir="rtl">
            <Zoom triggerOnce delay={(i / 2 + 1) * 100}>
              <Link href={item.disabled ? {} : item.url}>
                <a
                  onClick={(event) =>
                    item.disabled ? event.preventDefault() : null
                  }
                >
                  <Grid
                    container
                    className={`${
                      item.disabled || !data.has_wallet
                        ? classes.containerDisabled
                        : classes.container
                    }`}
                    alignItems="center"
                  >
                    <Grid item xs={12}>
                      <div className={classes.iconParent}>
                        <Image
                          src={item.image}
                          placeholder="blur"
                          blurDataURL={item.image}
                          alt="not found"
                          width={1}
                          height={1}
                          className={classes.image}
                          layout="responsive"
                        />
                      </div>
                      <Typography
                        variant="h5"
                        className={`${
                          item.disabled ? classes.t1Disable : classes.t1
                        }`}
                      >
                        {item.name}
                      </Typography>
                    </Grid>
                  </Grid>
                </a>
              </Link>
            </Zoom>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default Cards;
